import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import PubSub from "pubsub-js";
import {PubsubKeyEnum} from "../../../enums/pubsub-key.enum";
import {LibEnvironmentService} from "../../environment/lib-environment.service";

@Injectable({providedIn: 'root'})
export class SpidValidationsService {


  constructor(private http: HttpClient,
              private environmentService: LibEnvironmentService) {
  }

  private isOnTime() {
    const environment = this.environmentService.getEnvironment();
    const url = `${environment.apiPayments}/spid/onTime`;
    return this.http.get<any>(url);
  }

  async validateSpidOnTime(spid: any, toastMessage: string) {
    if (spid) {
      const isOnTime: any = await firstValueFrom(this.isOnTime())
      if (!isOnTime?.onTime) {
        const toast = {message: toastMessage, type: 'error', summary: 'Error'}
        PubSub.publish(PubsubKeyEnum.TOAST, toast)
        throw new Error(toastMessage);
      }
    }

  }
}
